var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('Footer'),_c('el-backtop',{attrs:{"bottom":128}},[_c('div',{staticClass:"back-top-button"},[_c('i',{staticClass:"el-icon-arrow-up"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }